import { isDevMode, Injectable } from '@angular/core'

const CONSOLE_DEBUG_METHOD = console['debug'] ? 'debug' : 'log'

@Injectable()
export class Logger {
  isDevMode: boolean

  constructor() {
    this.isDevMode = isDevMode()
  }

  debug(message?: any, ...optionalParams: any[]) {
    this.isDevMode && (<any>console)[CONSOLE_DEBUG_METHOD].apply(console, arguments)
  }

  info(message?: any, ...optionalParams: any[]) {
    console.info.apply(console, arguments)
  }

  warn(message?: any, ...optionalParams: any[]) {
    console.warn.apply(console, arguments)
  }

  error(message?: any, ...optionalParams: any[]) {
    console.error.apply(console, arguments)
  }
}
